import { render, staticRenderFns } from "./over.vue?vue&type=template&id=814f50bc&scoped=true"
import script from "./over.vue?vue&type=script&lang=js"
export * from "./over.vue?vue&type=script&lang=js"
import style0 from "./over.vue?vue&type=style&index=0&id=814f50bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814f50bc",
  null
  
)

export default component.exports